module.exports = __webpack_public_path__ + "static/media/hotelgift.d31f1d66.svg";